import { render } from "./SectionLCS.vue?vue&type=template&id=26b68234&scoped=true"
const script = {}

import "./SectionLCS.vue?vue&type=style&index=0&id=26b68234&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26b68234"]])

export default __exports__